export const breadcrumbsReducerKey = 'Breadcrumbs';
export const setBreadcrumbsOrderType = 'BREADCRUMBS_SET_ORDER_TYPE';
export const breadcrumbsRetrievedType = 'BREADCRUMBS_RETRIEVED_TYPE';
